import { SelectData } from '@occc-app/design-system';
import {
  Count_Products_By,
  Event_Purchase_Condition_Operator,
  Event_Targeting_Condition_Operator,
} from '@occc/graphql';
import {
  QualifiedEventsInitialFormValues,
  QualifiedEventType,
  TimePeriod,
} from '@occc-app/routes/Audience/types';
import { LastVisitValues } from '../LastVisit/types';

export const eventOptions: SelectData[] = [
  { label: 'Made a Purchase', value: QualifiedEventType.MadePurchase },
  { label: 'Fulfilled a Loyalty Event', value: QualifiedEventType.FulfilledLoyaltyEvent },
];

export const countProductsByOptions: SelectData[] = [
  { label: 'Product Quantity', value: Count_Products_By.Quantity },
  { label: 'Money Amount', value: Count_Products_By.MoneyAmount },
];

export enum QualifiedEventsMemberPurchasedOperator {
  MoreThan = 'MoreThan',
  MoreOrEqualTo = 'MoreOrEqualTo',
  LessThan = 'LessThan',
  LessThanOrEqualTo = 'LessThanOrEqualTo',
}

export const operatorToEventPurchaseConditionOperatorMap: Record<
  QualifiedEventsMemberPurchasedOperator,
  Event_Purchase_Condition_Operator
> = {
  MoreThan: Event_Purchase_Condition_Operator.AtLeast,
  MoreOrEqualTo: Event_Purchase_Condition_Operator.AtLeast,
  LessThan: Event_Purchase_Condition_Operator.AtMost,
  LessThanOrEqualTo: Event_Purchase_Condition_Operator.AtMost,
};

export const operatorOptions: SelectData[] = [
  {
    label: 'More than',
    value: QualifiedEventsMemberPurchasedOperator.MoreThan,
  },
  {
    label: 'More than or equal to',
    value: QualifiedEventsMemberPurchasedOperator.MoreOrEqualTo,
  },
  {
    label: 'Less than',
    value: QualifiedEventsMemberPurchasedOperator.LessThan,
  },
  {
    label: 'Less than or equal to',
    value: QualifiedEventsMemberPurchasedOperator.LessThanOrEqualTo,
  },
];

export const qualifiedEventsMemberPurchasedOperatorToTitleMap: Record<
  QualifiedEventsMemberPurchasedOperator,
  string
> = {
  [QualifiedEventsMemberPurchasedOperator.MoreThan]: 'More than',
  [QualifiedEventsMemberPurchasedOperator.MoreOrEqualTo]: 'More than or equal to',
  [QualifiedEventsMemberPurchasedOperator.LessThan]: 'Less than',
  [QualifiedEventsMemberPurchasedOperator.LessThanOrEqualTo]: 'Less than or equal to',
};

export const qualifiedEventsInitialFormValues: QualifiedEventsInitialFormValues = {
  event: QualifiedEventType.MadePurchase,
  countProductsBy: Count_Products_By.Quantity,
  operator: QualifiedEventsMemberPurchasedOperator.MoreThan,
  productGroups: [],
  locations: [],
  timePeriodType: TimePeriod.PreviousMonth,
  timesOperator: Event_Targeting_Condition_Operator.IsEqualTo,
};

export const lastVisitInitialFormValues: LastVisitValues = {
  amount: null,
  operator: '',
  period: '',
};

export const titleByOperator: Record<Event_Purchase_Condition_Operator, string> = {
  [Event_Purchase_Condition_Operator.AtLeast]: 'at least',
  [Event_Purchase_Condition_Operator.AtMost]: 'at most',
};

export const titleByEventType: Record<QualifiedEventType, string> = {
  [QualifiedEventType.MadePurchase]: 'Made a Purchase',
  [QualifiedEventType.FulfilledLoyaltyEvent]: 'Fulfilled a Loyalty Event',
};

export const timePeriodOptions: SelectData[] = [
  { label: 'Previous Month', value: TimePeriod.PreviousMonth },
  { label: 'Rolling Window', value: TimePeriod.RollingWindow },
  { label: 'Fixed Window', value: TimePeriod.FixedWindow },
];
